<template>
  <div class="not-suited-list">
    <p class="text-muted mb-3">
      Tradies you have marked as not suited do not see that job posting. Undo
      someone if it was a mistake and they will see that job again.
    </p>

    <p v-if="loading" class="text-muted py-3">Loading...</p>
    <p v-else-if="!entries.length" class="text-muted py-5 text-center">
      No one has been marked as not suited.
    </p>

    <div
      v-for="entry in entries"
      :key="entry.id"
      class="not-suited-row d-flex align-items-center justify-content-between"
    >
      <div>
        <div class="not-suited-name">{{ entry.name || 'Unknown tradie' }}</div>
        <div class="not-suited-meta">
          {{ entry.trade || 'No trade listed' }} &middot;
          {{ entry.job_title || 'All your jobs' }} &middot; Marked
          {{ formatDate(entry.marked_at) }}
        </div>
      </div>
      <b-button
        v-if="canManage"
        size="sm"
        variant="outline-primary"
        class="remove-not-suited-btn"
        :disabled="removingId === entry.id"
        @click="remove(entry)"
      >
        Undo
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import apiToasts from '@/mixins/apiToasts'
import { formatDate } from '@/utils/jobPostings'

// The company's "not suited" list. Presentational about permissions: the
// parent says whether the user may undo an entry (jobs.edit).
export default {
  name: 'NotSuitedList',

  mixins: [apiToasts],

  props: {
    canManage: Boolean,
  },

  data() {
    return {
      loading: false,
      entries: [],
      removingId: null,
    }
  },

  created() {
    this.load()
  },

  methods: {
    ...mapActions('jobPosting', ['fetchNotSuited', 'removeNotSuited']),

    formatDate,

    async load() {
      this.loading = true
      try {
        this.entries = await this.fetchNotSuited()
      } catch (err) {
        this.onError(err, 'Could not load the not suited list.')
      } finally {
        this.loading = false
      }
    },

    async remove(entry) {
      this.removingId = entry.id
      try {
        await this.removeNotSuited(entry.id)
        this.entries = this.entries.filter((e) => e.id !== entry.id)
        this.showToast('Success', 'Undone. They will see that job again.')
      } catch (err) {
        this.onError(err, 'Could not remove this tradie.')
      } finally {
        this.removingId = null
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// Gray values follow the newer Tailwind-style scale in DESIGN.md.
.not-suited-row {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  margin-bottom: 0.75rem;
  box-shadow: 0px 10px 25px #00429d0d;
}

.not-suited-name {
  font-weight: 700;
  color: #111827;
}

.not-suited-meta {
  font-size: 0.875rem;
  color: #6b7280;
}
</style>
